import { Modal, IconButton, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const TripDetailModal = ({ openPopup, handleCloseModal, }) => {

    return (
        <Modal
            open={Boolean(openPopup)}
            onClose={handleCloseModal}
            aria-labelledby="job-detail-modal"
            aria-describedby="job-detail-description"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    maxWidth: 600,
                    width: "100%",
                    borderRadius: 2,
                    outline: "none",
                }}
            >
                <IconButton
                    onClick={handleCloseModal}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: 'grey.500',
                    }}
                >
                    <CloseIcon />

                </IconButton>
            </Box>
        </Modal>
    )
}

export default TripDetailModal;